import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07c4bcfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "questionReference",
  class: "question-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "question-have-rule"
}
const _hoisted_3 = { class: "question-index-wrapper" }
const _hoisted_4 = { class: "d-flex flex-column flex-md-row" }
const _hoisted_5 = { class: "question-title-wrapper" }
const _hoisted_6 = { class: "question-type-wrapper" }
const _hoisted_7 = {
  key: 1,
  class: "mt-10"
}
const _hoisted_8 = {
  key: 3,
  class: "d-flex justify-content-end mt-4"
}
const _hoisted_9 = { class: "question-option-drop-down-position" }
const _hoisted_10 = { class: "d-flex justify-content-end mt-10" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "You have one unsaved question. Please save or cancel before switching to answer mode.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_title = _resolveComponent("question-title")!
  const _component_question_type_selector = _resolveComponent("question-type-selector")!
  const _component_question_rules = _resolveComponent("question-rules")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_option_drop_down_row = _resolveComponent("option-drop-down-row")!
  const _component_option_drop_down = _resolveComponent("option-drop-down")!
  const _component_question_actions = _resolveComponent("question-actions")!
  const _component_the_modal = _resolveComponent("the-modal")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.doesQuestionHaveRule)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.ix + 1) + ".", 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_question_title, {
          "is-active": _ctx.isActive,
          value: _ctx.question.text,
          onHandleQuestionTitleChange: _ctx.handleQuestionTitleChange
        }, null, 8, ["is-active", "value", "onHandleQuestionTitleChange"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_question_type_selector, {
          "is-active": _ctx.isActive,
          value: _ctx.question.type,
          onHandleTypeChange: _ctx.handleTypeChange
        }, null, 8, ["is-active", "value", "onHandleTypeChange"])
      ])
    ]),
    (!_ctx.isEditingRules)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.questionOptionsComponentAliases[_ctx.question.type]), {
            question: _ctx.question,
            ix: _ctx.ix,
            onUpdateAnswerOptions: _ctx.updateAnswerOptions,
            onRemoveAnswerOptionRule: _ctx.removeAnswerOptionRule
          }, null, 40, ["question", "ix", "onUpdateAnswerOptions", "onRemoveAnswerOptionRule"]))
        ]))
      : (_openBlock(), _createBlock(_component_question_rules, {
          key: 2,
          class: "mt-10",
          "all-questions": _ctx.allQuestions,
          ix: _ctx.ix,
          onCancelRules: _ctx.handleCancelRule,
          onSaveRules: _ctx.handleRuleSave
        }, null, 8, ["all-questions", "ix", "onCancelRules", "onSaveRules"])),
    (_ctx.question.isNewQuestion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "outlined",
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onCancelAddedQuestion', _ctx.ix)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "base",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onSaveAddedQuestion', _ctx.ix)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Save")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_option_drop_down, null, {
        default: _withCtx(() => [
          _createVNode(_component_option_drop_down_row, {
            text: "Answer Question",
            onHandleClick: _ctx.setAnswerMode
          }, null, 8, ["onHandleClick"]),
          _createVNode(_component_option_drop_down_row, {
            text: "Delete Question",
            onHandleClick: _ctx.removeQuestion
          }, null, 8, ["onHandleClick"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.isActive && !_ctx.question.isNewQuestion && !_ctx.isEditingRules)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_base_button, {
              class: "mr-10",
              variant: "outlined",
              onClick: _ctx.handleCancelEditQuestion
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_question_actions, {
              "question-type": _ctx.question.type,
              onHandleAddQuestion: _ctx.handleAddQuestion,
              onHandleAddRule: _ctx.handleAddRule
            }, null, 8, ["question-type", "onHandleAddQuestion", "onHandleAddRule"]),
            _createVNode(_component_base_button, { onClick: _ctx.handleUpdateQuestion }, {
              default: _withCtx(() => [
                _createTextVNode("Update")
              ]),
              _: 1
            }, 8, ["onClick"])
          ], 64))
        : _createCommentVNode("", true),
      (!_ctx.isActive && !_ctx.question.isNewQuestion)
        ? (_openBlock(), _createBlock(_component_base_button, {
            key: 1,
            variant: "outlined",
            onClick: _ctx.onEditClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("Edit")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_the_modal, {
      "is-visible": _ctx.preventAnswerModeModal.isOpen.value,
      onOnCancel: _ctx.preventAnswerModeModal.close,
      onOnConfirm: _ctx.preventAnswerModeModal.close
    }, {
      content: _withCtx(() => [
        _hoisted_11
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_base_button, {
          onClick: _ctx.preventAnswerModeModal.close
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ok")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["is-visible", "onOnCancel", "onOnConfirm"])
  ], 512)), [
    [_vShow, _ctx.currentCategory === _ctx.question.category_id]
  ])
}